export default [
    {
        target: '.radar-Guide-step-1',
        content: 'Your live command interface. Radar+ continuously scans for high-impact risks or opportunities and maps them here by urgency and likelihood.',
    },
    {
        target: '.radar-Guide-step-2',
        content: 'This tab reveals financial health signals — from revenue trends to spend anomalies — powered by your connected tools like QuickBooks or FreshBooks.',
    },
    {
        target: '.radar-Guide-step-3',
        content: 'Here, you’ll find project risks and bottlenecks. Radar+ flags slowdowns, misalignment, and missed execution based on your operational tools like Asana or Slack. Shows: Timeline issues, underperformance, flow gaps',
    },
    {
        target: '.radar-Guide-step-4',
        content: 'Track key compliance signals — like license expirations, audit flags, and policy violations — so you’re always ready, not reactive. Future integrations include legal, HR, and industry data feeds.',
    },
    {
        target: '.radar-Guide-step-5',
        content: 'Auto Execute takes action for you. Radar+ pushes tasks into your stack (Slack, Asana, etc.) based on smart rules — so things never fall through the cracks',
    },
    {
        target: '.radar-Guide-step-6',
        content: 'Wondering what these dots mean? This radar maps real-time signals by severity and likelihood. Hover over a dot to see more.',
    },
    {
        target: '.radar-Guide-step-7',
        content: 'See real-time shifts across your industry or sector. These external trends feed into your Radar to surface emerging opportunities and threats.',
    },
    {
        target: '.radar-Guide-step-8',
        content: 'Internal company patterns — hiring slowdowns, pipeline gaps, retention shifts — are surfaced here to show what’s brewing beneath the surface.',
    },
    {
        target: '.radar-Guide-step-9',
        content: 'Radar+ Tools are plug-and-play modules — like decision comparison, scenario simulation, and strategy tracking — to help you act with clarity.',
    },
    {
        target: '.radar-Guide-step-10',
        content: 'Manage and expand your data pipeline. Integrate key tools to get deeper, more accurate signal coverage.',
    },
    {
        target: '.radar-Guide-step-11',
        content: 'Coming soon: Settings',
    },
    {
        target: '.radar-Guide-step-12',
        content: 'Coming soon: A curated ecosystem of automations, add-ons, and AI agents that plug into Radar+ for advanced functionality.',
    },
]